import React from 'react';
import { HelpCircle, Info, Shield, AlertTriangle, History, Heart, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const HelpMenu: React.FC = () => {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className={cn(
              "w-10 h-10 rounded-full",
              "bg-card border border-border shadow-md",
              "flex items-center justify-center",
              "text-muted-foreground hover:text-foreground",
              "hover:shadow-lg transition-all duration-200"
            )}
          >
            <HelpCircle className="w-5 h-5" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" side="top" className="w-56 mb-2">
          <DropdownMenuLabel className="text-xs text-muted-foreground font-normal">
            Informations
          </DropdownMenuLabel>
          
          <DropdownMenuItem asChild>
            <Link to="/a-propos" className="flex items-center gap-3 cursor-pointer">
              <Info className="w-4 h-4" />
              <span>À propos</span>
            </Link>
          </DropdownMenuItem>
          
          <DropdownMenuItem asChild>
            <Link to="/rgpd" className="flex items-center gap-3 cursor-pointer">
              <Shield className="w-4 h-4" />
              <span>RGPD</span>
            </Link>
          </DropdownMenuItem>
          
          <DropdownMenuItem asChild>
            <Link to="/clause-non-responsabilite" className="flex items-center gap-3 cursor-pointer">
              <AlertTriangle className="w-4 h-4" />
              <span>Clause de non-responsabilité</span>
            </Link>
          </DropdownMenuItem>
          
          <DropdownMenuItem asChild>
            <Link to="/changelog" className="flex items-center gap-3 cursor-pointer">
              <History className="w-4 h-4" />
              <span>Changelog</span>
            </Link>
          </DropdownMenuItem>
          
          <DropdownMenuSeparator />
          
          <DropdownMenuItem asChild>
            <a 
              href="https://polemia.com/faireundon/" 
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 cursor-pointer text-primary font-medium"
            >
              <Heart className="w-4 h-4 text-destructive fill-destructive" />
              <span>Faire un don</span>
              <ExternalLink className="w-3 h-3 ml-auto opacity-50" />
            </a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default HelpMenu;
